import { render } from "./ColorPickerModal.vue?vue&type=template&id=5aed2f0e&scoped=true"
import script from "./ColorPickerModal.vue?vue&type=script&lang=js"
export * from "./ColorPickerModal.vue?vue&type=script&lang=js"

import "./ColorPickerModal.vue?vue&type=style&index=0&id=5aed2f0e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5aed2f0e"]])

export default __exports__